import React, { useEffect, useRef, useState } from "react";

const useKeyboardNavigation = ({
  list = [],
  onEnter = () => {},
  isActive = true,
  enableScroll = true,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const rowRefs = useRef([]);

  useEffect(() => {
    if (enableScroll) {
      rowRefs.current = list.map(
        (_, i) => rowRefs.current[i] || React.createRef()
      );
    }
    setSelectedIndex(list.length > 0 ? 0 : -1);
  }, [list, enableScroll]);

  // Handle key events
  useEffect(() => {
    if (!isActive || list.length === 0) return;

    const handleKeyDown = (e) => {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setSelectedIndex((prev) => Math.min(prev + 1, list.length - 1));
          break;
        case "ArrowUp":
          e.preventDefault();
          setSelectedIndex((prev) => Math.max(prev - 1, 0));
          break;
        case "PageDown":
          e.preventDefault();
          setSelectedIndex((prev) => Math.min(prev + 10, list.length - 1));
          break;
        case "PageUp":
          e.preventDefault();
          setSelectedIndex((prev) => Math.max(prev - 10, 0));
          break;
        case "Home":
          e.preventDefault();
          setSelectedIndex(0);
          break;
        case "End":
          e.preventDefault();
          setSelectedIndex(list.length - 1);
          break;
        case "Enter":
          if (selectedIndex >= 0 && selectedIndex < list.length) {
            onEnter(list[selectedIndex]);
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [list, selectedIndex, onEnter, isActive]);

  // Scroll into view when selectedIndex changes
  useEffect(() => {
    if (!enableScroll) return;
    const selectedRef = rowRefs.current[selectedIndex];
    if (selectedRef?.current) {
      selectedRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex, enableScroll]);

  return {
    selectedIndex,
    setSelectedIndex,
    rowRefs,
  };
};

export default useKeyboardNavigation;
